


document.addEventListener( 'DOMContentLoaded', () => {

  const items:Array<HTMLDivElement> = [];
  let locSelect:HTMLSelectElement | null = null;
  let depSelect:HTMLSelectElement | null = null;
  let typeSelect:HTMLSelectElement | null = null;

  const loopItems = ( ) => {
    items.map( item => {

      let visible = 0;

      const i_loc = item.getAttribute( 'data-loc' );
      const i_dep = item.getAttribute( 'data-dep' );
      const i_type = item.getAttribute( 'data-type' );

      if( i_loc == 'all' || i_loc == locSelect.value || locSelect.value == 'all' )
        visible ++;

      if( i_dep == 'all' || i_dep == depSelect.value || depSelect.value == 'all' )
        visible ++;

      if( i_type == 'all' || i_type == typeSelect.value || typeSelect.value == 'all' )
        visible ++;


      if( visible != 3 )
        item.classList.add( 'hidden' );
      else if ( item.classList.contains( 'hidden' ) )
        item.classList.remove( 'hidden' );
    } );
  };

  //declare career container
  const cont = document.getElementById( 'ess-career-post-list-container-static' );

  if ( cont ) {

    //move career posts to area
    cont.querySelectorAll( '.esc-list-item' ).forEach( item=>{
      items.push( item as HTMLDivElement );
    } );

    //Get filter selects
    locSelect = cont.querySelector( '#escf-loc' );
    depSelect = cont.querySelector( '#escf-dep' );
    typeSelect = cont.querySelector( '#escf-type' );

    locSelect.addEventListener( 'change', () => loopItems( ) );
    depSelect.addEventListener( 'change', () => loopItems( ) );
    typeSelect.addEventListener( 'change', () => loopItems( ) );

  }

} );

